var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf-login-user" }, [
    _c(
      "div",
      { staticClass: "login-box-info" },
      [
        _c("el-input", {
          attrs: {
            disabled: _vm.$attrs.loading,
            placeholder: _vm.$attrs.userNamePlaceholder,
            size: "medium",
            "prefix-icon": "el-icon-user-solid",
          },
          model: {
            value: _vm.username,
            callback: function ($$v) {
              _vm.username = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "username",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "login-box-info" },
      [
        _c("el-input", {
          attrs: {
            disabled: _vm.$attrs.loading,
            type: "password",
            placeholder: _vm.$attrs.passwordPlaceholder,
            size: "medium",
            "prefix-icon": "el-icon-s-goods",
          },
          model: {
            value: _vm.password,
            callback: function ($$v) {
              _vm.password = typeof $$v === "string" ? $$v.trim() : $$v
            },
            expression: "password",
          },
        }),
      ],
      1
    ),
    _vm.$attrs.isShowCode
      ? _c(
          "div",
          { staticClass: "login-box-info login-code" },
          [
            _c("el-input", {
              attrs: {
                disabled: _vm.$attrs.loading,
                type: "text",
                placeholder: _vm.$attrs.codePlaceholder,
                size: "medium",
                "prefix-icon": "iconfont icon-yanzhengma1",
              },
              model: {
                value: _vm.code,
                callback: function ($$v) {
                  _vm.code = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "code",
              },
            }),
            _c("img", {
              staticClass: "img-code",
              attrs: { src: _vm.$attrs.codeUrl },
              on: {
                click: function ($event) {
                  return _vm.$emit("updateCodeUrl")
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "login-box-info login-password" },
      [
        _c(
          "el-checkbox",
          {
            model: {
              value: _vm.remember,
              callback: function ($$v) {
                _vm.remember = $$v
              },
              expression: "remember",
            },
          },
          [_vm._v("记住密码")]
        ),
        _vm.$attrs.isForgotPassword
          ? _c("div", { staticClass: "login-box-forgot-password" }, [
              _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("toForgotPassword")
                    },
                  },
                },
                [_vm._v("忘记密码?")]
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }